<template>
    <div class="register" :class="isThemeAja ? 'aja-bg-main' : ''">
        <Navigation />
        <v-main>
            <v-container style="min-height: 100vh">
                <v-row justify="center" class="mt-5">
                    <v-col cols="10">
                        <v-card :class="isThemeAja ? 'aja-bg-card' : ''">
                            <CardTitle :text="cardTitle" />
                            <v-card-text>
                                <RegisterStepper />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import RegisterStepper from '@/components/registerStepper'
import { mapGetters } from 'vuex'

export default {
    components: {
        RegisterStepper
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        cardTitle() {
            return !this.$store.getters.getProfile?.id ? 'Créer mon compte' : 'Je finalise mon adhésion'
        }
    }
}
</script>
